import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Navbar";

const PAGES = [
  { label: "Home", to: "/" },
  { label: "Approach", to: "/approach" },
  { label: "Capabilities", to: "/capabilities" },
  { label: "Experience", to: "/experience" },
  { label: "Insights", to: "/insights" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-slate-300">
      <div className="mx-auto max-w-7xl px-6 pb-10 pt-16 sm:pt-20">
        <div className="grid gap-12 border-b border-white/10 pb-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <Wordmark dark />
            <p className="mt-6 max-w-sm font-serif text-2xl leading-snug text-white">
              Understand. Improve. Monitor.
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              Product and transformation advisory for organizations improving or replacing
              complex systems — from discovery through measurable outcomes.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.3em] text-slate-500">PAGES</p>
            <ul className="mt-5 space-y-2.5">
              {PAGES.map((p) => (
                <li key={p.to}>
                  <Link
                    to={p.to}
                    data-testid={`footer-link-${p.label.toLowerCase()}`}
                    className="text-sm text-slate-300 transition-colors hover:text-white"
                  >
                    {p.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.3em] text-slate-500">START</p>
            <p className="mt-5 text-sm leading-relaxed text-slate-400">
              Describe the outcome you are seeing. We will help you trace the system behind it.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-discuss"
              className="mt-5 inline-flex items-center gap-1.5 border border-white/25 px-5 py-3 text-sm tracking-wide text-white transition-colors duration-300 hover:bg-white hover:text-navy"
            >
              Discuss a System
            </Link>
          </div>
        </div>
        <div className="flex flex-col gap-3 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-slate-500">© 2026 Improve Systems. All rights reserved.</p>
          <p className="font-mono text-[10px] tracking-[0.3em] text-slate-500">
            PRODUCT & TRANSFORMATION ADVISORY
          </p>
        </div>
      </div>
    </footer>
  );
}
